import * as centers from '../centers/centers.const';
import * as county from '../masterdata/county/county.const';
import {STATE_MA} from '../masterdata/states/state.const';
import * as et from '../masterdata/system/entity-type.const';
import * as rel from '../masterdata/system/relationship-to-center.const';

export const ENTITY_MBF_ID = '507f1f77bcf86cd799439014';
export const ENTITY_EOHLC_ID = '507f1f77bcf86cd799439011';
export const ENTITY_AGO_FTFMP_ID = '507f1f77bcf86cd799439015';

export const ENTITY_DHCD = {
    _id: ENTITY_EOHLC_ID,
    centers: centers.CENTERS_DHCD,
    name: 'EOHLC',
    description: 'Department of Housing and Community Development',
    type: et.STATE_GOVERNMENT,
    contact: {
        addressLine1: '100 Cambridge St.',
        addressLine2: 'Suite 300',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02114',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    reporting: true,
    hmp: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY],
    // CRUD
    editable: false,
    deletable: false,
    activatable: false,
};

export const DOR_CSE = {
    _id: '507f1f77bcf86cd799439013',
    centers: centers.CENTERS_PMP,
    name: 'DOR CSE (PMP)',
    description: 'Department of Revenue Child Support Enforcement Division - Parent Mediation Program',
    type: et.STATE_GOVERNMENT,
    contact: {
        addressLine1: '100 Cambridge St.',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02114',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    reporting: true,
    pmp: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY],
    // CRUD
    editable: false,
    activatable: false,
    deletable: false,
};

export const ENTITY_MBF = {
    _id: ENTITY_MBF_ID,
    centers: centers.CENTERS_MBF,
    name: 'MBF',
    description: 'Massachusetts Bar Foundation',
    type: et.LOCAL_BUSINESS,
    active: true,
    contact: {
        addressLine1: '20 West St.',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02111',
        officePhone: '(617) 338-0534',
        county: county.COUNTY_SUFFOLK,
    },
    // Activity
    reporting: true,
    mbf: true,
    funder: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.FUNDER],
    // CRUD
    editable: false,
    activatable: false,
    deletable: false,
};

export const AGO_FTFMP = {
    _id: ENTITY_AGO_FTFMP_ID,
    centers: centers.CENTERS.map(c => c._id),
    name: 'AGO FTFMP',
    description: `Attorney General's Office Face to Face Mediation Program`,
    type: et.STATE_GOVERNMENT,
    contact: {
        addressLine1: '1 Ashburton Pl',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02108',
        officePhone: '(617) 727-2200',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    reporting: true,
    ftFmp: true,
    funder: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.FUNDER],
    // CRUD
    editable: false,
    activatable: false,
    deletable: false,
};

export const ENTITY_NBDC = {
    _id: '507f1f77bcf86cd799439012',
    centers: [centers.U413._id],
    name: 'Northern Berkshire District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '111 Holden St.',
        city: 'North Adams',
        state: STATE_MA,
        zipCode: '01247',
        officePhone: '(413) 663-5339',
        county: county.COUNTY_BERKSHIRE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_PDC = {
    _id: '507f1f77bcf86cd799439016',
    centers: [centers.U413._id],
    name: 'Pittsfield District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '24 Wendell Ave.',
        addressLine2: 'P.O. Box 875',
        city: 'Pittsfield',
        state: STATE_MA,
        zipCode: '01202',
        officePhone: '(413) 499-0558',
        county: county.COUNTY_BERKSHIRE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_SBDC = {
    _id: '507f1f77bcf86cd799439017',
    centers: [centers.U413._id],
    name: 'Southern Berkshire District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '9 Gilmore Ave.',
        city: 'Great Barrington',
        state: STATE_MA,
        zipCode: '01230',
        officePhone: '(413) 528-3520',
        county: county.COUNTY_BERKSHIRE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_BDC = {
    _id: '507f1f77bcf86cd799439018',
    centers: [centers.CCDRC._id],
    name: 'Barnstable District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '3195 Main St.',
        addressLine2: 'P.O. Box 398',
        city: 'Barnstable',
        state: STATE_MA,
        zipCode: '02630',
        officePhone: '(508) 375-6778',
        county: county.COUNTY_BARNSTABLE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_FDC = {
    _id: '507f1f77bcf86cd799439019',
    centers: [centers.CCDRC._id],
    name: 'Falmouth District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '161 Jones Rd.',
        city: 'Falmouth',
        state: STATE_MA,
        zipCode: '02540',
        officePhone: '(508) 495-1500',
        county: county.COUNTY_BARNSTABLE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_NDC = {
    _id: '507f1f77bcf86cd799439020',
    centers: [centers.CCDRC._id],
    name: 'Nantucket District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '16 Broad St.',
        city: 'Nantucket',
        state: STATE_MA,
        zipCode: '02554',
        officePhone: '(508) 228-0460',
        county: county.COUNTY_NANTUCKET,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_ODC = {
    _id: '507f1f77bcf86cd799439021',
    centers: [centers.CCDRC._id],
    name: 'Orleans District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '237 Rock Harbor Road',
        city: 'Orleans',
        state: STATE_MA,
        zipCode: '02653',
        officePhone: '(508) 255-4700',
        county: county.COUNTY_BARNSTABLE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_CDC = {
    _id: '507f1f77bcf86cd799439022',
    centers: [centers.CDSC._id],
    name: 'Cambridge District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '4040 Mystic Valley Parkway',
        city: 'Medford',
        state: STATE_MA,
        zipCode: '02155',
        officePhone: '(781) 306-2715',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WDC = {
    _id: '507f1f77bcf86cd799439023',
    centers: [centers.CDSC._id, centers.MCC._id],
    name: 'Waltham District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '38 Linden Street',
        city: 'Waltham',
        state: STATE_MA,
        zipCode: '02452',
        officePhone: '(781) 894-4500',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WODC = {
    _id: '507f1f77bcf86cd799439024',
    centers: [centers.CDSC._id],
    name: 'Woburn District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '30 Pleasant Street',
        city: 'Woburn',
        state: STATE_MA,
        zipCode: '01801',
        officePhone: '(781) 935-4000',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_GDC = {
    _id: '507f1f77bcf86cd799439025',
    centers: [centers.CRG._id],
    name: 'Greenfield District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '43 Hope St.',
        city: 'Greenfield',
        state: STATE_MA,
        zipCode: '01301',
        officePhone: '(413) 774-5533',
        county: county.COUNTY_FRANKLIN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_HDC = {
    _id: '507f1f77bcf86cd799439026',
    centers: [centers.CRG._id],
    name: 'Holyoke District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '20 Court Plaza',
        city: 'Holyoke',
        state: STATE_MA,
        zipCode: '01040',
        officePhone: '(413) 538-9710',
        county: county.COUNTY_HAMPDEN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_NODC = {
    _id: '507f1f77bcf86cd799439027',
    centers: [centers.CRG._id],
    name: 'Northampton District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '15 Gothic St.',
        city: 'Northampton',
        state: STATE_MA,
        zipCode: '01060',
        officePhone: '(413) 584-7400',
        county: county.COUNTY_HAMPSHIRE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_DDC = {
    _id: '507f1f77bcf86cd799439028',
    centers: [centers.FSCM._id],
    name: 'Dudley District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '279 West Main St.',
        city: 'Dudley',
        state: STATE_MA,
        zipCode: '01571',
        officePhone: '(508) 943-7123',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MDC = {
    _id: '507f1f77bcf86cd799439029',
    centers: [centers.FSCM._id],
    name: 'Milford District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '161 West St.',
        city: 'Milford',
        state: STATE_MA,
        zipCode: '01757',
        officePhone: '(508) 473-1260',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_UDC = {
    _id: '507f1f77bcf86cd799439030',
    centers: [centers.FSCM._id],
    name: 'Uxbridge District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '261 South Main Street',
        city: 'Uxbridge',
        state: STATE_MA,
        zipCode: '01569',
        officePhone: '(508) 278-2454',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WEDC = {
    _id: '507f1f77bcf86cd799439031',
    centers: [centers.FSCM._id],
    name: 'Westborough District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '186 Oak Street',
        city: 'Westborough',
        state: STATE_MA,
        zipCode: '01581',
        officePhone: '(508) 366-8266',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WORDC = {
    _id: '507f1f77bcf86cd799439032',
    centers: [centers.FSCM._id],
    name: 'Worcester District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '225 Main St.',
        city: 'Worcester',
        state: STATE_MA,
        zipCode: '01608',
        officePhone: '(508) 831-2010',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_BRDC = {
    _id: '507f1f77bcf86cd799439033',
    centers: [centers.GBCDR._id],
    name: 'Brockton District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '215 Main St.',
        city: 'Brockton',
        state: STATE_MA,
        zipCode: '02301',
        officePhone: '(508) 587-8000',
        county: county.COUNTY_PLYMOUTH,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_ADC = {
    _id: '507f1f77bcf86cd799439034',
    centers: [centers.MCC._id],
    name: 'Ayer District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '25 East Main St.',
        city: 'Ayer',
        state: STATE_MA,
        zipCode: '01432',
        officePhone: '(978) 772-2100',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_CODC = {
    _id: '507f1f77bcf86cd799439035',
    centers: [centers.MCC._id, centers.MWMS._id],
    name: 'Concord District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '305 Walden St.',
        city: 'Concord',
        state: STATE_MA,
        zipCode: '01742',
        officePhone: '(978) 369-0500',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_LDC = {
    _id: '507f1f77bcf86cd799439036',
    centers: [centers.MCC._id],
    name: 'Lowell District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '370 Jackson St.',
        city: 'Lowell',
        state: STATE_MA,
        zipCode: '01852',
        officePhone: '(978) 459-4101',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_BRODC = {
    _id: '507f1f77bcf86cd799439037',
    centers: [centers.MMS._id],
    name: 'Brookline District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '360 Washington St.',
        city: 'Brookline',
        state: STATE_MA,
        zipCode: '02445',
        officePhone: '(617) 232-4660',
        county: county.COUNTY_NORFORK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_CHDC = {
    _id: '507f1f77bcf86cd799439038',
    centers: [centers.MMS._id],
    name: 'Chelsea District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '120 Broadway',
        city: 'Chelsea',
        state: STATE_MA,
        zipCode: '02150',
        officePhone: '(617) 660-9200',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MADC = {
    _id: '507f1f77bcf86cd799439039',
    centers: [centers.MMS._id],
    name: 'Malden District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '4040 Mystic Valley Parkway',
        city: 'Medford',
        state: STATE_MA,
        zipCode: '02155',
        officePhone: '(781) 322-7500',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_NEDC = {
    _id: '507f1f77bcf86cd799439040',
    centers: [centers.MMS._id],
    name: 'Newton District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '1309 Washington St.',
        city: 'West Newton',
        state: STATE_MA,
        zipCode: '02465',
        officePhone: '(617) 244-3600',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_SDC = {
    _id: '507f1f77bcf86cd799439041',
    centers: [centers.MMS._id],
    name: 'Stoughton District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '1288 Central St.',
        city: 'Stoughton',
        state: STATE_MA,
        zipCode: '02072',
        officePhone: '(781) 344-2131',
        county: county.COUNTY_NORFORK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_FIDC = {
    _id: '507f1f77bcf86cd799439042',
    centers: [centers.MSI._id],
    name: 'Fitchburg District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '100 Elm St.',
        city: 'Fitchburg',
        state: STATE_MA,
        zipCode: '01420',
        officePhone: '(978) 345-2111',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_GADC = {
    _id: '507f1f77bcf86cd799439043',
    centers: [centers.MSI._id],
    name: 'Gardner District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '108 Matthews St.',
        city: 'Gardner',
        state: STATE_MA,
        zipCode: '01440',
        officePhone: '(978) 632-2373',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_LEDC = {
    _id: '507f1f77bcf86cd799439044',
    centers: [centers.MSI._id],
    name: 'Leominster District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '25 School St.',
        city: 'Leominster',
        state: STATE_MA,
        zipCode: '01453',
        officePhone: '(978) 537-3722',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WIDC = {
    _id: '507f1f77bcf86cd799439045',
    centers: [centers.MSI._id],
    name: 'Winchendon District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '108 Matthews Street',
        city: 'Gardner',
        state: STATE_MA,
        zipCode: '01440',
        officePhone: '(978) 632-6326',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_ATDC = {
    _id: '507f1f77bcf86cd799439046',
    centers: [centers.MVMP._id],
    name: 'Attleboro District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '88 North Main St.',
        city: 'Attleboro',
        state: STATE_MA,
        zipCode: '02703',
        officePhone: '(508) 222-5900',
        county: county.COUNTY_BRISTOL,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_EDC = {
    _id: '507f1f77bcf86cd799439047',
    centers: [centers.MVMP._id],
    name: 'Edgartown District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '81 Main St.',
        city: 'Edgartown',
        state: STATE_MA,
        zipCode: '02539',
        officePhone: '(508) 627-3751',
        county: county.COUNTY_DUKES,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_FRDC = {
    _id: '507f1f77bcf86cd799439048',
    centers: [centers.MVMP._id],
    name: 'Fall River District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '186 S. Main St.',
        addressLine2: '5th Floor',
        city: 'Fall River',
        state: STATE_MA,
        zipCode: '02720',
        officePhone: '(508) 491-3200',
        county: county.COUNTY_BRISTOL,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_NBEDC = {
    _id: '507f1f77bcf86cd799439049',
    centers: [centers.MVMP._id],
    name: 'New Bedford District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '75 N. Sixth St.',
        city: 'New Bedford',
        state: STATE_MA,
        zipCode: '02740',
        officePhone: '(508) 999-9700',
        county: county.COUNTY_BRISTOL,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_TDC = {
    _id: '507f1f77bcf86cd799439050',
    centers: [centers.MVMP._id],
    name: 'Taunton District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '40 Broadway',
        city: 'Taunton',
        state: STATE_MA,
        zipCode: '02780',
        officePhone: '(508) 977-6000',
        county: county.COUNTY_BRISTOL,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_FRADC = {
    _id: '507f1f77bcf86cd799439051',
    centers: [centers.MWMS._id],
    name: 'Framingham District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '600 Concord St.',
        addressLine2: 'PO Box 1969',
        city: 'Framingham',
        state: STATE_MA,
        zipCode: '01701',
        officePhone: '(508) 875-7461',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MARDC = {
    _id: '507f1f77bcf86cd799439052',
    centers: [centers.MWMS._id],
    name: 'Marlborough District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '45 Williams St.',
        city: 'Marlborough',
        state: STATE_MA,
        zipCode: '01752',
        officePhone: '(508) 485-3700',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_NADC = {
    _id: '507f1f77bcf86cd799439053',
    centers: [centers.MWMS._id],
    name: 'Natick District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '600 Concord St.',
        city: 'Framingham',
        state: STATE_MA,
        zipCode: '01701',
        officePhone: '(508) 620-9110',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_GLDC = {
    _id: '507f1f77bcf86cd799439054',
    centers: [centers.TRC._id],
    name: 'Gloucester District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '197 Main St.',
        city: 'Gloucester',
        state: STATE_MA,
        zipCode: '01930',
        officePhone: '(978) 283-2620',
        county: county.COUNTY_ESSEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_PEDC = {
    _id: '507f1f77bcf86cd799439055',
    centers: [centers.TRC._id],
    name: 'Peabody District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '1 Lowell St.',
        city: 'Peabody',
        state: STATE_MA,
        zipCode: '01960',
        officePhone: '(978) 532-3100',
        county: county.COUNTY_ESSEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_SADC = {
    _id: '507f1f77bcf86cd799439056',
    centers: [centers.TRC._id],
    name: 'Salem District Court',
    description: '',
    type: et.COURT_DISTRICT,
    contact: {
        addressLine1: '56 Federal St.',
        city: 'Salem',
        state: STATE_MA,
        zipCode: '01970',
        officePhone: '(978) 744-1167',
        county: county.COUNTY_ESSEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_BD = {
    _id: '507f1f77bcf86cd799439057',
    centers: [centers.MMS._id],
    name: 'Brighton Division',
    description: '',
    type: et.COURT_BMC,
    contact: {
        addressLine1: '52 Academy Hill Rd.',
        city: 'Brighton',
        state: STATE_MA,
        zipCode: '02135',
        officePhone: '(617) 782-6540',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_CD = {
    _id: '507f1f77bcf86cd799439058',
    centers: [centers.MMS._id],
    name: 'Central Division',
    description: '',
    type: et.COURT_BMC,
    contact: {
        addressLine1: '24 New Chardon Street',
        addressLine2: 'Edward W. Brooke Courthouse',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02114',
        officePhone: '(617) 788-8600',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_CHD = {
    _id: '507f1f77bcf86cd799439059',
    centers: [centers.CDSC._id, centers.MMS._id],
    name: 'Charlestown Division',
    description: '',
    type: et.COURT_BMC,
    contact: {
        addressLine1: '3 City Square',
        city: 'Charlestown',
        state: STATE_MA,
        zipCode: '02129',
        officePhone: '(617) 242-5400',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_DD = {
    _id: '507f1f77bcf86cd799439060',
    centers: [centers.MMS._id],
    name: 'Dorchester Division',
    description: '',
    type: et.COURT_BMC,
    contact: {
        addressLine1: '510 Washington St.',
        city: 'Dorchester',
        state: STATE_MA,
        zipCode: '02124',
        officePhone: '(617) 288-9500',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_EBD = {
    _id: '507f1f77bcf86cd799439061',
    centers: [centers.MMS._id],
    name: 'East Boston Division',
    description: '',
    type: et.COURT_BMC,
    contact: {
        addressLine1: '37 Meridian St.',
        city: 'East Boston',
        state: STATE_MA,
        zipCode: '02128',
        officePhone: '(617) 569-7550',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WRD = {
    _id: '507f1f77bcf86cd799439062',
    centers: [centers.MMS._id],
    name: 'West Roxbury Division',
    description: '',
    type: et.COURT_BMC,
    contact: {
        addressLine1: '445 Arborway',
        city: 'Jamaica Plain',
        state: STATE_MA,
        zipCode: '02130',
        officePhone: '(617) 971-1200',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_SBD = {
    _id: '507f1f77bcf86cd799445062',
    centers: [centers.MMS._id],
    name: 'South Boston Division',
    type: et.COURT_BMC,
    contact: {
        addressLine1: '535 East Broadway',
        city: 'South Boston',
        state: STATE_MA,
        zipCode: '02127',
        officePhone: '(617) 268-7321',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_RD = {
    _id: '507f1f77bcf86cd799446062',
    centers: [centers.MMS._id],
    name: 'Roxbury Division',
    type: et.COURT_BMC,
    contact: {
        addressLine1: '85 Warren St.',
        city: 'Roxbury',
        state: STATE_MA,
        zipCode: '02119',
        officePhone: '(617) 427-7000',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_SCSSBHC = {
    _id: '507f1f77bcf86cd799439063',
    centers: [centers.MMS._id],
    name: 'Suffolk County House of Correction ',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '20 Bradston St',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02118',
        officePhone: '(617) 635-1000',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MCSJHC = {
    _id: '507f1f77bcf86cd799439064',
    centers: [centers.CDSC._id],
    name: `Middlesex County Jail & House of Correction`,
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '269 Treble Cove Rd',
        addressLine2: 'North Billerica',
        city: 'Billerica',
        state: STATE_MA,
        zipCode: '01862',
        officePhone: '(978) 667-1711',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_DCSJHC = {
    _id: '507f1f77bcf86cd799439065',
    centers: [centers.MVMP._id],
    name: 'Dukes County Sheriff Jail and House of Correction',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '149 Main St',
        city: 'Edgartown',
        state: STATE_MA,
        zipCode: '02539',
        officePhone: '(508) 627-5173',
        county: county.COUNTY_DUKES,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WCSJHC = {
    _id: '507f1f77bcf86cd799439066',
    centers: [centers.MSI._id],
    name: 'Worcester County Sheriff Jail and House of Correction',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '5 Paul X Tivnan Dr',
        city: 'West Boylston',
        state: STATE_MA,
        zipCode: '01583',
        officePhone: '(508) 854-1800',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_FCSJ = {
    _id: '507f1f77bcf86cd799439067',
    centers: [centers.CRG._id],
    name: 'Franklin County Sheriff Jail',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '160 Elm St',
        city: 'Greenfield',
        state: STATE_MA,
        zipCode: '01301',
        officePhone: '(413) 774-4014',
        county: county.COUNTY_FRANKLIN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_HCSHC = {
    _id: '507f1f77bcf86cd799439068',
    centers: [centers.CRG._id],
    name: 'Hampshire County Sheriff House of Correction',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '205 Rocky Hill Road',
        city: 'Northampton',
        state: STATE_MA,
        zipCode: '01060',
        officePhone: '(413) 584-5911',
        county: county.COUNTY_HAMPSHIRE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_HCSMS = {
    _id: '507f1f77bcf86cd799439069',
    centers: [centers.CRG._id],
    name: 'Hamden County Sheriff - Mill Street',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '155 Mill Street',
        city: 'Springfield',
        state: STATE_MA,
        zipCode: '01108',
        officePhone: '(413) 886-0110',
        county: county.COUNTY_HAMPDEN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_HCSCC = {
    _id: '507f1f77bcf86cd799439070',
    centers: [centers.CRG._id],
    name: 'Hamden County Sheriff Correctional Center',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '627 Randall Road',
        city: 'Ludlow',
        state: STATE_MA,
        zipCode: '01056',
        officePhone: '(413) 858-0000',
        county: county.COUNTY_HAMPDEN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_HCSRWCC = {
    _id: '507f1f77bcf86cd799439071',
    centers: [centers.CRG._id],
    name: "Hampden County Sheriff W MA Regional Women's Correctional Center",
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '701 Center St',
        city: 'Chicopee',
        state: STATE_MA,
        zipCode: '01013',
        officePhone: '(413) 730-6800',
        county: county.COUNTY_HAMPDEN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_ECSRPC = {
    _id: '507f1f77bcf86cd799439072',
    centers: [centers.TRC._id],
    name: 'Essex County Sheriff re-entry and Pre-release Center',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '165 Marston St',
        city: 'Lawrence',
        state: STATE_MA,
        zipCode: '01841',
        officePhone: '(978) 750-1900',
        officePhoneExt: '4309',
        county: county.COUNTY_ESSEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MCIC = {
    _id: '507f1f77bcf86cd799439073',
    centers: [centers.MWMS._id],
    name: 'MCI Concord (DOC)',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '965 Elm St',
        city: 'Concord',
        state: STATE_MA,
        zipCode: '01742',
        officePhone: '(978) 405-6100',
        county: county.COUNTY_MIDDLESEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_NECC = {
    _id: '507f1f77bcf86cd799439074',
    centers: [centers.MWMS._id],
    name: 'North Eastern Correctional Center (DOC)',
    description: '',
    type: et.CORRECTIONALFACILITY,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MS = {
    _id: '507f1f77bcf86cd799439075',
    centers: [centers.MSI._id],
    name: 'MCI Shirley (DOC)',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '104 Harvard Road',
        city: 'Shirley',
        state: STATE_MA,
        zipCode: '01464',
        county: county.COUNTY_MIDDLESEX,
        officePhone: '(978) 425-4341',
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MF = {
    _id: '507f1f77bcf86cd799439076',
    centers: [centers.MWMS._id],
    name: 'MCI Framingham (DOC)',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '99 Loring Dr.',
        addressLine2: 'P.O. Box 9007',
        city: 'Framingham',
        state: STATE_MA,
        zipCode: '01701',
        county: county.COUNTY_MIDDLESEX,
        officePhone: '(508) 532-5100',
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MN = {
    _id: '507f1f77bcf86cd799439077',
    centers: [centers.MMS._id],
    name: 'MCI Norfolk (DOC)',
    description: '',
    type: et.CORRECTIONALFACILITY,
    contact: {
        addressLine1: '2 Clark St.',
        addressLine2: 'P.O. Box 43',
        city: 'Norfolk',
        state: STATE_MA,
        zipCode: '02056',
        county: county.COUNTY_NORFORK,
        officePhone: '(508) 660-5900',
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: false,
    reEntry: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

// Probate and Family courts
export const ENTITY_BAPFC = {
    _id: '507f1f77bcf86cd799440001',
    centers: [centers.MVMP._id],
    name: 'Barnstable Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '3195 Main St.',
        addressLine2: 'P.O. Box 346',
        city: 'Barnstable',
        state: STATE_MA,
        zipCode: '02630',
        officePhone: '(508) 375-6710',
        county: county.COUNTY_BARNSTABLE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_BRPFC = {
    _id: '507f1f77bcf86cd799440002',
    centers: [centers.MVMP._id],
    name: 'Bristol Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '40 Broadway, Suite 240',
        city: 'Taunton',
        state: STATE_MA,
        zipCode: '02780',
        officePhone: '(508) 977-6040',
        county: county.COUNTY_BRISTOL,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_DUPFC = {
    _id: '507f1f77bcf86cd799440003',
    centers: [centers.MVMP._id],
    name: 'Dukes Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '81 Main St.',
        addressLine2: 'P.O. Box 237',
        city: 'Edgartown',
        state: STATE_MA,
        zipCode: '02539',
        officePhone: '(508) 627-4703',
        county: county.COUNTY_DUKES,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_ESPFC = {
    _id: '507f1f77bcf86cd799440004',
    centers: [centers.TRC._id],
    name: 'Essex Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '36 Federal St.',
        city: 'Salem',
        state: STATE_MA,
        zipCode: '01970',
        officePhone: '(978) 744-1020',
        county: county.COUNTY_ESSEX,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_FRPFC = {
    _id: '507f1f77bcf86cd799440005',
    centers: [centers.CRG._id],
    name: 'Franklin Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '43 Hope St.',
        addressLine2: 'P.O. Box 590',
        city: 'Greenfield',
        state: STATE_MA,
        zipCode: '01302',
        officePhone: '(413) 774-7011',
        county: county.COUNTY_FRANKLIN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_HDPFC = {
    _id: '507f1f77bcf86cd799440006',
    centers: [centers.CRG._id],
    name: 'Hampden Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '50 State St.',
        addressLine2: 'P.O. Box 559',
        city: 'Springfield',
        state: STATE_MA,
        zipCode: '01102',
        officePhone: '(413) 748-7760',
        county: county.COUNTY_HAMPDEN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_HSPFC = {
    _id: '507f1f77bcf86cd799440007',
    centers: [centers.CRG._id],
    name: 'Hampshire Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '15 Atwood Dr.',
        city: 'Northampton',
        state: STATE_MA,
        zipCode: '01060',
        officePhone: '(413) 586-8500',
        county: county.COUNTY_HAMPSHIRE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MSPFC = {
    _id: '507f1f77bcf86cd799440008',
    centers: [centers.CDSC._id, centers.MMS._id, centers.MWMS._id],
    name: 'Middlesex Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_NFPFC = {
    _id: '507f1f77bcf86cd799440009',
    centers: [centers.CDSC._id, centers.MMS._id],
    name: 'Norfolk Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '35 Shawmut Road',
        city: 'Canton',
        state: STATE_MA,
        zipCode: '02021',
        officePhone: '(781) 830-1200',
        county: county.COUNTY_NORFORK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_PLPFC = {
    _id: '507f1f77bcf86cd799440010',
    centers: [centers.GBCDR._id],
    name: 'Plymouth Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '52 Obery St.',
        city: 'Plymouth',
        state: STATE_MA,
        zipCode: '02360',
        officePhone: '(508) 747-6204',
        county: county.COUNTY_PLYMOUTH,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_SFPFC = {
    _id: '507f1f77bcf86cd799440011',
    centers: [centers.CDSC._id, centers.MMS._id],
    name: 'Suffolk Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '24 New Chardon St.',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02114',
        officePhone: '(617) 788-8301',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WOPFC = {
    _id: '507f1f77bcf86cd799440012',
    centers: [centers.FSCM._id],
    name: 'Worcester Probate and Family Court',
    type: et.COURT_PROBATE_FAMILY,
    contact: {
        addressLine1: '225 Main Street',
        city: 'Worcester',
        state: STATE_MA,
        zipCode: '01608',
        officePhone: '(508) 831-2200',
        county: county.COUNTY_WORCESTER,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

// Juvenile Courts
export const ENTITY_BACJC = {
    _id: '507f1f77bcf86cd799440017',
    centers: [centers.GBCDR._id, centers.MVMP._id],
    name: 'Barnstable County Juvenile Court',
    type: et.COURT_JUVENILE,
    contact: {
        addressLine1: '3195 Main Street',
        addressLine2: 'P.O. Box 427',
        city: 'Barnstable',
        state: STATE_MA,
        zipCode: '02630',
        officePhone: '(508) 362-1389',
        county: county.COUNTY_BARNSTABLE,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_BECJC = {
    _id: '507f1f77bcf86cd799440018',
    centers: [centers.U413._id],
    name: 'Berkshire County Juvenile Court',
    type: et.COURT_JUVENILE,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_BRCJC = {
    _id: '507f1f77bcf86cd799440019',
    centers: [centers.MVMP._id],
    name: 'Bristol County Juvenile Court',
    type: et.COURT_JUVENILE,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_ESCJC = {
    _id: '507f1f77bcf86cd799440020',
    centers: [centers.TRC._id],
    name: 'Essex County Juvenile Court',
    type: et.COURT_JUVENILE,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_FHCJC = {
    _id: '507f1f77bcf86cd799440021',
    centers: [centers.CRG._id],
    name: 'Franklin-Hampshire County Juvenile Court',
    type: et.COURT_JUVENILE,
    contact: {
        addressLine1: '43 Hope St',
        city: 'Greenfield',
        state: STATE_MA,
        zipCode: '01302',
        officePhone: '(413) 775-0014',
        county: county.COUNTY_FRANKLIN,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_MSCJC = {
    _id: '507f1f77bcf86cd799440022',
    centers: [centers.CDSC._id, centers.MWMS._id, centers.MMS._id, centers.MCC._id],
    name: 'Middlesex County Juvenile Court',
    type: et.COURT_JUVENILE,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_NFCJC = {
    _id: '507f1f77bcf86cd799440023',
    centers: [centers.MMS._id],
    name: 'Norfolk County Juvenile Court',
    type: et.COURT_JUVENILE,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_PLCJC = {
    _id: '507f1f77bcf86cd799440024',
    centers: [centers.GBCDR._id],
    name: 'Plymouth County Juvenile Court',
    type: et.COURT_JUVENILE,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_SFCJC = {
    _id: '507f1f77bcf86cd799440025',
    centers: [centers.MMS._id],
    name: 'Suffolk County Juvenile Court',
    type: et.COURT_JUVENILE,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_WOCJC = {
    _id: '507f1f77bcf86cd799440026',
    centers: [centers.FSCM._id],
    name: 'Worcester County Juvenile Court',
    type: et.COURT_JUVENILE,
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

// Other Entities
export const ENTITY_LC = {
    _id: '507f1f77bcf86cd799440027',
    centers: [centers.CDSC._id, centers.MWMS._id],
    name: 'Land Court',
    type: et.COURT_LAND,
    contact: {
        addressLine1: '3 Pemberton Square, 5th Floor',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02108',
        officePhone: '(617) 788-7470',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_SC = {
    _id: '507f1f77bcf86cd799440028',
    centers: [centers.U413._id, centers.MWMS._id, centers.MMS._id, centers.MCC._id],
    name: 'Superior Court',
    type: et.COURT_SUPERIOR,
    contact: {
        addressLine1: '3 Pemberton Square, 13th Floor',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02108',
        officePhone: '(617) 788-8130',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_HC = {
    _id: '507f1f77bcf86cd799440029',
    centers: [centers.U413._id, centers.MWMS._id],
    name: 'Housing Court',
    type: et.COURT_HOUSING,
    contact: {
        addressLine1: 'Edward W. Brooke Courthouse',
        addressLine2: '24 New Chardon Street, 6th Floor',
        city: 'Boston',
        state: STATE_MA,
        zipCode: '02114',
        officePhone: '(617) 788-6500',
        county: county.COUNTY_SUFFOLK,
    },
    active: true,
    // Activity
    referral: true,
    reporting: true,
    court: true,
    relationshipToCenter: [rel.REPORTING_ORG_AGENCY, rel.REFERRAL_SOURCE],
    // CRUD
    editable: true,
    deletable: true,
};

export const ENTITY_ALL = [
    ENTITY_DHCD,
    ENTITY_NBDC,
    DOR_CSE,
    ENTITY_MBF,
    AGO_FTFMP,
    ENTITY_PDC,
    ENTITY_SBDC,
    ENTITY_BDC,
    ENTITY_FDC,
    ENTITY_NDC,
    ENTITY_ODC,
    ENTITY_CDC,
    ENTITY_WDC,
    ENTITY_WODC,
    ENTITY_GDC,
    ENTITY_HDC,
    ENTITY_NODC,
    ENTITY_DDC,
    ENTITY_MDC,
    ENTITY_UDC,
    ENTITY_WEDC,
    ENTITY_WORDC,
    ENTITY_BRDC,
    ENTITY_ADC,
    ENTITY_CODC,
    ENTITY_LDC,
    ENTITY_BRODC,
    ENTITY_CHDC,
    ENTITY_MADC,
    ENTITY_NEDC,
    ENTITY_SDC,
    ENTITY_FIDC,
    ENTITY_GADC,
    ENTITY_LEDC,
    ENTITY_WIDC,
    ENTITY_ATDC,
    ENTITY_EDC,
    ENTITY_FRDC,
    ENTITY_NBEDC,
    ENTITY_TDC,
    ENTITY_FRADC,
    ENTITY_MARDC,
    ENTITY_NADC,
    ENTITY_GLDC,
    ENTITY_PEDC,
    ENTITY_SADC,
    ENTITY_BD,
    ENTITY_CD,
    ENTITY_CHD,
    ENTITY_DD,
    ENTITY_EBD,
    ENTITY_WRD,
    ENTITY_SBD,
    ENTITY_RD,
    ENTITY_SCSSBHC,
    ENTITY_MCSJHC,
    ENTITY_DCSJHC,
    ENTITY_WCSJHC,
    ENTITY_FCSJ,
    ENTITY_HCSHC,
    ENTITY_HCSMS,
    ENTITY_HCSCC,
    ENTITY_HCSRWCC,
    ENTITY_ECSRPC,
    ENTITY_MCIC,
    ENTITY_NECC,
    ENTITY_MS,
    ENTITY_MF,
    ENTITY_MN,
    ENTITY_BAPFC,
    ENTITY_BRPFC,
    ENTITY_DUPFC,
    ENTITY_ESPFC,
    ENTITY_FRPFC,
    ENTITY_HDPFC,
    ENTITY_HSPFC,
    ENTITY_MSPFC,
    ENTITY_NFPFC,
    ENTITY_PLPFC,
    ENTITY_SFPFC,
    ENTITY_WOPFC,
    ENTITY_BACJC,
    ENTITY_BECJC,
    ENTITY_BRCJC,
    ENTITY_ESCJC,
    ENTITY_FHCJC,
    ENTITY_MSCJC,
    ENTITY_NFCJC,
    ENTITY_PLCJC,
    ENTITY_SFCJC,
    ENTITY_WOCJC,
    ENTITY_LC,
    ENTITY_SC,
    ENTITY_HC,
];
